// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

swiper-container {
  height: 100%;
}

.margin-top-value {
  margin-top: 10px;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  overflow: auto;
}

ion-slide {
  width: 100% !important;
  padding: 10px;
}
ion-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  padding: 20px;
  text-align: left;
}

@media (min-width: 991px) {
  ion-content {
    height: 80%;
  }
}

.form-row {
  padding: 5px 25px 20px;
}

.slots-row {
  padding: 5px 25px 20px;
  display: flex;
  flex-direction: column;
}
.slots-row h2 {
  color: white !important;
}

.form-card {
  background-color: var(--background-color);
  padding: 12px 6px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.phone-item {
  border: none;
}
.phone-item ion-input:first-child {
  margin-right: 10px;
}
.phone-item ion-input {
  margin-bottom: 5px;
  border-bottom: 1px solid var(--ion-color-dark);
}

.label-error {
  color: rgb(119, 25, 25);
}

ion-card {
  margin: 0;
  padding: 12px;
  border-radius: 0px;
  text-align: initial;
  --color: var(--ion-color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
  border: 0.5px solid #e2dcd5;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
}
ion-card:first-of-type {
  margin-bottom: 10px;
}
ion-card ion-card-content {
  border-top: 0.5px solid #e2dcd5;
  padding: 0px;
  line-break: auto !important;
}
ion-card ion-card-content:first-of-type {
  border: none;
}
ion-card ion-card-content .padding-card {
  padding: 10px;
}
ion-card ion-col {
  padding: 0;
}

ion-card-header {
  background: white;
  color: var(--ion-color-black);
  padding: 0;
}
ion-card-header .separator {
  margin-block: 20px;
}
ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  border: 1.5px solid white;
  text-transform: none;
}

.left-col {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
}
@media (min-width: 991px) {
  .left-col {
    font-size: 16px;
    line-height: 20px;
  }
}

.right-col {
  font-family: AppFont;
  font-size: 10px;
  line-height: 15px;
  text-align: right;
  color: #1a1a18;
}
@media (min-width: 991px) {
  .right-col {
    font-size: 14px;
    line-height: 20px;
  }
}

.border-top-light-blue {
  border-top: 0.5px solid #e2dcd5;
}
.border-top-light-blue h3 {
  margin-top: 10px;
  place-self: center;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
}

ion-chip {
  margin: 0;
  margin-left: auto;
  background: var(--ion-color-primary);
  padding: 2px 10px;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: unset;
  width: -moz-fit-content;
  width: fit-content;
}
ion-chip ion-label {
  font-family: AppFontBold;
  font-size: 9px;
  line-height: 10px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
}
@media (min-width: 991px) {
  ion-chip ion-label {
    font-size: 12px;
    line-height: 14px;
  }
}

.card-content-md {
  font-weight: unset;
}

.adds-price {
  padding-left: 5px;
  color: var(--ion-color-medium);
}

.order-at-header {
  text-align: left;
  margin: 10px;
  margin-left: 0px;
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  font-weight: bold;
  color: var(--ion-color-black);
}

ion-label {
  text-align: left;
}

.padding {
  padding: 25px;
}

.icon-edit {
  zoom: 2;
}

.privacy {
  font-family: OpenSans, sans-serif;
  font-size: 11px;
  color: var(--ion-color-black);
}

.phoneCountry {
  max-width: 15%;
}
@media (min-width: 991px) {
  .phoneCountry {
    max-width: 10%;
  }
}

ion-card-title {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: var(--ion-color-black);
  font-size: 18px;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-image: url('dot.svg');
  background-size: 7px 100%;
}
.separator--wide .line {
  background-size: 8px 100%;
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 10px 17px;
}

.button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 12px;
}
.button-row .footer-btn {
  min-height: 46px;
  height: 46px;
  width: max-content;
  --padding-start: 5px;
  --padding-end: 5px;
  --padding-top: 5px;
  --padding-bottom: 5px;
  position: relative;
}
.button-row .footer-btn .footer-btn-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  color: #fff;
}
.button-row .footer-btn .button-img {
  width: 35px;
  height: 35px;
}
.button-row .button-total {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: min-content;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  margin-left: auto;
  text-align: right;
  color: #000;
  text-transform: uppercase;
}
.button-row .button-total span {
  font-family: AppFontBold;
  font-size: 18px;
  color: #000;
}

.footer-info-title {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 19px;
}

ion-radio-group {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  color: #000;
}
ion-radio-group ion-radio {
  --border-width: 1px;
  --border-color: #000;
  --border-color-checked: #000;
  --background-checked: transparent;
  --color-checked: #000;
  --color: #000;
}
ion-radio-group ion-radio::part(label) {
  text-overflow: initial;
  white-space: initial;
}
ion-radio-group .radio-checked::part(mark) {
  transform: scale3d(1.4, 1.4, 1);
}
ion-radio-group .additional-info {
  display: block;
  margin-top: 12px;
  font-family: AppFont;
  font-size: 10px;
  line-height: 13px;
  text-align: left;
  color: #1a1a18;
}

.main-overview-row {
  padding: 16px 25px;
}

.articles-row ~ :not(.tip-row) {
  margin-bottom: 12px;
}

.tip-row {
  margin-bottom: 12px;
}

app-tip {
  display: block;
  margin-bottom: 12px;
}

.article-row {
  margin-bottom: 8px;
}

.name-col {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
}
@media (min-width: 991px) {
  .name-col {
    font-size: 16px;
    line-height: 20px;
  }
}

.article-price {
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  color: #000;
}
@media (min-width: 991px) {
  .article-price {
    font-size: 14px;
    line-height: 20px;
  }
}

.total-row {
  margin-top: 20px;
}
.total-row .total-title {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
  margin: 0;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .total-row .total-title {
    font-size: 16px;
    line-height: 20px;
  }
}
.total-row .price {
  font-family: AppFontBold;
  font-size: 15px;
  line-height: 15px;
  text-align: right;
  color-scheme: #000;
  margin: 0;
}
@media (min-width: 991px) {
  .total-row .price {
    font-size: 16px;
    line-height: 20px;
  }
}

.wrapper-send-letter {
  display: flex;
  flex-direction: column;
  background: white;
  padding: 10px;
  width: max-content;
}

.container {
  position: relative;
  margin-bottom: 20px;
}
.container ion-label {
  background: white;
  z-index: 999;
  left: 10px;
  padding: 0px 4px;
  font-size: 11px;
  color: #6b6b6b;
}

.input-error {
  --color: red;
  --placeholder-color: red;
  margin-bottom: 0 !important;
}

.error-text {
  margin: 4px 0;
  width: 100%;
  color: red;
  font-size: x-small;
}

.input_group-1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.input_group-1 .lock-icon {
  height: 12px;
}
@media (min-width: 991px) {
  .input_group-1 .lock-icon {
    margin: 2px -10px 15px 5px;
  }
}
.input_group-1--1 {
  width: 70% !important;
  margin-right: 0;
}
.input_group-1--2 {
  margin: 0px 7px 20px;
  width: 30% !important;
}

.input_group-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
}
.input_group-2 .lock-icon {
  height: 12px;
}
@media (min-width: 991px) {
  .input_group-2 .lock-icon {
    margin: 2px -10px 15px 5px;
  }
}
.input_group-2--1 {
  width: 30%;
  margin-right: 0;
}
.input_group-2--2 {
  width: 70%;
  margin: 0 7px 20px;
}

.option-name ion-col {
  font-size: 12px !important;
}

.stacked {
  position: relative;
  top: 10px;
  left: 10px;
  z-index: 2;
  background: #fff;
  padding-inline: 5px;
  width: -moz-fit-content;
  width: fit-content;
}

.separator_white_wrapper {
  width: 100%;
  padding: 20px 25px;
}
.separator_white_wrapper .separator_white {
  height: 14px;
  width: 100%;
  background: url('separator_doted_white.svg') no-repeat center center/100% 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAIA;EACC,YAAA;AADD;;AAGA;EACC,gBAAA;AAAD;;AAEA;EACC,sBAAA;EACA,uBAAA;AACD;;AAEA;EACC,cAAA;AACD;;AAEA;EACC,sBAAA;EACA,aAAA;AACD;AAAC;EACC,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAEF;;AC/BE;EDgCF;IAEE,WAAA;EAEA;AACF;;AAAA;EACC,sBAAA;AAGD;;AAAA;EACC,sBAAA;EAEA,aAAA;EACA,sBAAA;AAED;AADC;EACC,uBAAA;AAGF;;AACA;EACC,yCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAED;;AACA;EACC,YAAA;AAED;AADC;EACC,kBAAA;AAGF;AADC;EACC,kBAAA;EACA,8CAAA;AAGF;;AAAA;EACC,uBAAA;AAGD;;AADA;EACC,SAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EAEA,+BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,wDAAA;AAGD;AADC;EACC,mBAAA;AAGF;AAAC;EACC,+BAAA;EACA,YAAA;EACA,2BAAA;AAEF;AADE;EACC,YAAA;AAGH;AADE;EACC,aAAA;AAGH;AACC;EACC,UAAA;AACF;;AAGA;EACC,iBAAA;EACA,6BAAA;EACA,UAAA;AAAD;AAEC;EACC,kBAAA;AAAF;AAGC;EACC,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AADF;;AAKA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAHD;AC9HE;ED2HF;IAQE,eAAA;IACA,iBAAA;EADA;AACF;;AAIA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EAEA,cAAA;AAHD;AC5IE;EDwIF;IASE,eAAA;IACA,iBAAA;EADA;AACF;;AAIA;EACC,+BAAA;AADD;AAEC;EACC,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;AAAF;;AAIA;EACC,SAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;AADD;AAGC;EACC,wBAAA;EACA,cAAA;EACA,iBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,WAAA;AAFF;ACjLE;ED4KD;IASE,eAAA;IACA,iBAAA;EAAD;AACF;;AAIA;EACC,kBAAA;AADD;;AAIA;EACC,iBAAA;EACA,8BAAA;AADD;;AAGA;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oCAAA;EACA,iBAAA;EACA,6BAAA;AAAD;;AAEA;EACC,gBAAA;AACD;;AAEA;EACC,aAAA;AACD;;AACA;EACC,OAAA;AAED;;AAAA;EACC,iCAAA;EACA,eAAA;EACA,6BAAA;AAGD;;AADA;EACC,cAAA;AAID;AClOE;ED6NF;IAGE,cAAA;EAMA;AACF;;AAHA;EACC,oCAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;AAMD;;AAHA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAMD;AAJC;EACC,WAAA;EACA,gCAAA;EACA,yBAAA;AAMF;AAJC;EACC,yBAAA;AAMF;;AAFA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;AAKD;;AAFA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAKD;AAHC;EACC,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAKF;AAJE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,WAAA;AAKH;AAFE;EACC,WAAA;EACA,YAAA;AAIH;AAAC;EACC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,iBAAA;EACA,WAAA;EACA,yBAAA;AACF;AAAE;EACC,wBAAA;EACA,eAAA;EACA,WAAA;AAEH;;AAGA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;AAAD;;AAIA;EACC,aAAA;EACA,yBAAA;EAEA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAJD;AAKC;EACC,mBAAA;EAEA,oBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qBAAA;EACA,aAAA;AAJF;AAME;EACC,sBAAA;EACA,oBAAA;AAJH;AAOC;EACC,+BAAA;AALF;AAQC;EACC,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;AAPF;;AAWA;EACC,kBAAA;AARD;;AAWA;EACC,mBAAA;AARD;;AAWA;EACC,mBAAA;AARD;;AAWA;EACC,cAAA;EACA,mBAAA;AARD;;AAWA;EACC,kBAAA;AARD;;AAWA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AATD;AC1XE;ED6XF;IAQE,eAAA;IACA,iBAAA;EAPA;AACF;;AASA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,WAAA;AAPD;ACxYE;EDyYF;IAQE,eAAA;IACA,iBAAA;EALA;AACF;;AAQA;EACC,gBAAA;AALD;AAOC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AALF;AC3ZE;EDyZD;IASE,eAAA;IACA,iBAAA;EAHD;AACF;AAMC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,SAAA;AALF;ACzaE;EDuaD;IASE,eAAA;IACA,iBAAA;EAHD;AACF;;AAOA;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AAJD;;AAMA;EACC,kBAAA;EACA,mBAAA;AAHD;AAIC;EAGE,iBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAJH;;AAOE;EACD,YAAA;EACA,wBAAA;EACA,2BAAA;AAJD;;AAOE;EACD,aAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AAJD;;AAME;EACD,aAAA;EACA,uBAAA;EACA,mBAAA;AAHD;AAIC;EACE,YAAA;AAFH;AC1dE;ED2dD;IAGC,0BAAA;EAAA;AACF;AAEC;EACC,qBAAA;EACA,eAAA;AAAF;AAEC;EACC,oBAAA;EACA,qBAAA;AAAF;;AAIE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AADH;AAGC;EACE,YAAA;AADH;ACjfE;EDifD;IAGC,0BAAA;EACA;AACF;AAOC;EACC,UAAA;EACA,eAAA;AALF;AAQC;EACC,UAAA;EACA,kBAAA;AANF;;AAWC;EACC,0BAAA;AARF;;AAYE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACF,gBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AATF;;AAWA;EACC,WAAA;EACA,kBAAA;AARD;AASC;EACC,YAAA;EACA,WAAA;EACA,8EAAA;AAPF","sourcesContent":["@import '../../../theme/mixins';\n\n:root {\n\t--ion-padding: 12px;\n}\n\nswiper-container {\n\theight: 100%;\n}\n.margin-top-value {\n\tmargin-top: 10px;\n  }\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\toverflow: auto;\n}\n\nion-slide {\n\twidth: 100% !important;\n\tpadding: 10px;\n\t> ion-col {\n\t\toverflow: auto;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tposition: absolute;\n\t\tpadding: 20px;\n\t\ttext-align: left;\n\t}\n}\nion-content {\n\t@include desktop {\n\t\theight: 80%;\n\t}\n}\n.form-row {\n\tpadding: 5px 25px 20px;\n\t\n}\n.slots-row {\n\tpadding: 5px 25px 20px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\th2 {\n\t\tcolor: white !important;\n\t}\n}\n\n.form-card {\n\tbackground-color: var(--background-color);\n\tpadding: 12px 6px;\n\tmargin-top: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.phone-item {\n\tborder: none;\n\tion-input:first-child {\n\t\tmargin-right: 10px;\n\t}\n\tion-input {\n\t\tmargin-bottom: 5px;\n\t\tborder-bottom: 1px solid var(--ion-color-dark);\n\t}\n}\n.label-error {\n\tcolor: rgb(119, 25, 25);\n}\nion-card {\n\tmargin: 0;\n\tpadding: 12px;\n\tborder-radius: 0px;\n\ttext-align: initial;\n\n\t--color: var(--ion-color-black);\n\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\toverflow: auto;\n\tword-break: break-word;\n\tborder: 0.5px solid #e2dcd5;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n\n\t&:first-of-type {\n\t\tmargin-bottom: 10px;\n\t}\n\n\tion-card-content {\n\t\tborder-top: 0.5px solid #e2dcd5;\n\t\tpadding: 0px;\n\t\tline-break: auto !important;\n\t\t&:first-of-type {\n\t\t\tborder: none;\n\t\t}\n\t\t.padding-card {\n\t\t\tpadding: 10px;\n\t\t}\n\t}\n\n\tion-col {\n\t\tpadding: 0;\n\t}\n}\n\nion-card-header {\n\tbackground: white;\n\tcolor: var(--ion-color-black);\n\tpadding: 0;\n\n\t.separator {\n\t\tmargin-block: 20px;\n\t}\n\n\tion-button {\n\t\t--background: transparent;\n\t\t--color: #54504c;\n\t\tborder: 1.5px solid white;\n\t\ttext-transform: none;\n\t}\n}\n\n.left-col {\n\tfont-family: AppFontBold;\n\tfont-size: 13px;\n\tline-height: 16px;\n\n\ttext-align: left;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t}\n}\n\n.right-col {\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 15px;\n\n\ttext-align: right;\n\n\tcolor: #1a1a18;\n\t@include desktop {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n}\n\n.border-top-light-blue {\n\tborder-top: 0.5px solid #e2dcd5;\n\th3 {\n\t\tmargin-top: 10px;\n\t\tplace-self: center;\n\t\tfont-size: 16px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n}\n\nion-chip {\n\tmargin: 0;\n\tmargin-left: auto;\n\tbackground: var(--ion-color-primary);\n\tpadding: 2px 10px;\n\tborder-radius: 28px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: unset;\n\twidth: fit-content;\n\n\tion-label {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 9px;\n\t\tline-height: 10px;\n\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\t@include desktop {\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 14px;\n\t\t}\n\t}\n}\n\n.card-content-md {\n\tfont-weight: unset;\n}\n\n.adds-price {\n\tpadding-left: 5px;\n\tcolor: var(--ion-color-medium);\n}\n.order-at-header {\n\ttext-align: left;\n\tmargin: 10px;\n\tmargin-left: 0px;\n\tfont-size: 20px;\n\tline-height: 24px;\n\ttext-transform: uppercase;\n\tfont-family: AppFontBold, sans-serif;\n\tfont-weight: bold;\n\tcolor: var(--ion-color-black);\n}\nion-label {\n\ttext-align: left;\n}\n\n.padding {\n\tpadding: 25px;\n}\n.icon-edit {\n\tzoom: 2;\n}\n.privacy {\n\tfont-family: OpenSans, sans-serif;\n\tfont-size: 11px;\n\tcolor: var(--ion-color-black);\n}\n.phoneCountry {\n\tmax-width: 15%;\n\t@include desktop {\n\t\tmax-width: 10%;\n\t}\n}\n\nion-card-title {\n\tfont-family: AppFontBold, sans-serif;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-black);\n\tfont-size: 18px;\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n\t&--wide .line {\n\t\tbackground-size: 8px 100%;\n\t}\n}\n\n.footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: stretch;\n\tpadding: 10px 17px;\n}\n\n.button-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tmargin-top: 12px;\n\n\t.footer-btn {\n\t\tmin-height: 46px;\n\t\theight: 46px;\n\t\twidth: max-content;\n\t\t--padding-start: 5px;\n\t\t--padding-end: 5px;\n\t\t--padding-top: 5px;\n\t\t--padding-bottom: 5px;\n\t\tposition: relative;\n\t\t.footer-btn-text {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 14px;\n\n\t\t\ttext-align: center;\n\t\t\tcolor: #fff;\n\n\t\t}\n\t\t.button-img {\n\t\t\twidth: 35px;\n\t\t\theight: 35px;\n\t\t}\n\t}\n\n\t.button-total {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: flex-end;\n\t\twidth: min-content;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tmargin-left: auto;\n\n\t\ttext-align: right;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t\tspan {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 18px;\n\t\t\tcolor: #000;\n\t\t}\n\t}\n}\n\n.footer-info-title {\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 19px;\n\n}\n\nion-radio-group {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\n\tmargin-bottom: 12px;\n\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 17px;\n\n\ttext-align: left;\n\tcolor: #000;\n\tion-radio {\n\t\t--border-width: 1px;\n\n\t\t--border-color: #000;\n\t\t--border-color-checked: #000;\n\t\t--background-checked: transparent;\n\t\t--color-checked: #000;\n\t\t--color: #000;\n\n\t\t&::part(label) {\n\t\t\ttext-overflow: initial;\n\t\t\twhite-space: initial;\n\t\t}\n\t}\n\t.radio-checked::part(mark) {\n\t\ttransform: scale3d(1.4, 1.4, 1);\n\t}\n\n\t.additional-info {\n\t\tdisplay: block;\n\t\tmargin-top: 12px;\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 13px;\n\n\t\ttext-align: left;\n\t\tcolor: #1a1a18;\n\t}\n}\n\n.main-overview-row {\n\tpadding: 16px 25px;\n}\n\n.articles-row ~ :not(.tip-row) {\n\tmargin-bottom: 12px;\n}\n\n.tip-row {\n\tmargin-bottom: 12px;\n}\n\napp-tip {\n\tdisplay: block;\n\tmargin-bottom: 12px;\n}\n\n.article-row {\n\tmargin-bottom: 8px;\n}\n\n.name-col {\n\tfont-family: AppFontBold;\n\tfont-size: 13px;\n\tline-height: 16px;\n\n\ttext-align: left;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t}\n}\n.article-price {\n\tfont-family: AppFontBold;\n\tfont-size: 12px;\n\tline-height: 15px;\n\n\ttext-align: right;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n}\n\n.total-row {\n\tmargin-top: 20px;\n\n\t.total-title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 13px;\n\t\tline-height: 16px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\tmargin: 0;\n\t\ttext-transform: uppercase;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n\n\t.price {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 15px;\n\t\tline-height: 15px;\n\n\t\ttext-align: right;\n\t\tcolor-scheme: #000;\n\t\tmargin: 0;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n}\n\n.wrapper-send-letter {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: white;\n\tpadding: 10px;\n\twidth: max-content;\n}\n.container {\n\tposition: relative;\n\tmargin-bottom: 20px;\n\tion-label {\n\t//   position: absolute;\n\t//   top: -7px;\n\t  background: white;\n\t  z-index: 999;\n\t  left: 10px;\n\t  padding: 0px 4px;\n\t  font-size: 11px;\n\t  color: #6b6b6b;\n\t}\n  }\n  .input-error {\n\t--color: red;\n\t--placeholder-color: red;\n\tmargin-bottom: 0 !important;\n  }\n  \n  .error-text {\n\tmargin: 4px 0;\n\twidth: 100%;\n\tcolor: red;\n\tfont-size: x-small;\n  }\n  .input_group-1 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t.lock-icon {\n\t  height: 12px;\n\t  @include desktop {\n\t\tmargin: 2px -10px 15px 5px;\n\t  }\n\t}\n\t&--1 {\n\t\twidth: 70% !important;\n\t\tmargin-right: 0;\n\t}\n\t&--2 {\n\t\tmargin: 0px 7px 20px;\n\t\twidth: 30% !important;\n\t}\n  }\n  \n  .input_group-2 {\n\t  display: flex;\n\t  justify-content: center;\n\t  align-items: center;\n\t  padding: 0 12px;\n  \n\t.lock-icon {\n\t  height: 12px;\n\t  @include desktop {\n\t\tmargin: 2px -10px 15px 5px;\n\t  }\n\t}\n  \n\t.container {\n\n\n\t}\n  \n\t&--1 {\n\t\twidth: 30%;\n\t\tmargin-right: 0;\n\t}\n  \n\t&--2 {\n\t\twidth: 70%;\n\t\tmargin: 0 7px 20px;\n\t}\n  }\n  \n  .option-name {\n\tion-col {\n\t\tfont-size: 12px !important;\n\t}\n  }\n\n  .stacked {\n    position: relative;\n    top: 10px;\n    left: 10px;\n    z-index: 2;\n\t\tbackground: #fff;\n\t\tpadding-inline: 5px;\n\t\twidth: fit-content;\n}\n.separator_white_wrapper {\n\twidth: 100%;\n\tpadding: 20px 25px;\n\t.separator_white {\n\t\theight: 14px;\n\t\twidth: 100%;\n\t\tbackground: url('../../../assets/icon/separator_doted_white.svg') no-repeat center center/ 100% 100%;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
